import { useState, useEffect } from 'react';

const useIsWebview = () => {
  const [isWebview, setIsWebview] = useState(false);

  useEffect(() => {
    // Only check after hydration on the client
    const checkWebview =
      typeof window !== 'undefined' &&
      window.navigator.userAgent.includes('PierreWebView');
    setIsWebview(checkWebview);
  }, []);

  return [isWebview];
};

export default useIsWebview;
